import {Basic, Ventrata} from 'types'

export const convertUnitItemsToUnitCounterMap = (unitItems: Ventrata.UnitItem[]): Basic.UnitCounterMap => {
  const map: Basic.UnitCounterMap = {}

  for (const unitItem of unitItems) {
    if (map[unitItem.unitId]) {
      map[unitItem.unitId]++
    } else {
      map[unitItem.unitId] = 1
    }
  }

  return map
}
